<app-widgets-loader *ngIf="customerId && siteId"
	key="battery-reports"
	[data]="{
		data: data,
		siteId: siteId,
		customerId: customerId,
		isACTuser: user.isACTuser
	}"
	[passAllDataOnce]="true"
></app-widgets-loader>